module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-by.a95db9f3.png";